import * as React from 'react';
import {
    Edit,
    required,
    SimpleForm,
    TextInput,
} from 'react-admin';
import AzureStorageTitle from './AzureStorageTitle';

const AzureStorageEdit = props => (
    <Edit title={<AzureStorageTitle />} {...props}>
        <SimpleForm>
            <TextInput source="account_name" validate={required()} />
            <TextInput source="account_key" validate={required()} />
            <TextInput source="container" />
        </SimpleForm>
    </Edit>
);

export default AzureStorageEdit;